module.exports = "https://img1.huilianyi.com/d/ap-request.d3b49f4880.appcore.png";